/**
 * Superadmin Webhook Status Constants
 * Centralized status definitions for superadmin webhook delivery status
 */

// Webhook status values
export const SUPERADMIN_WEBHOOK_STATUSES = {
  SUCCESS: 'success',
  FAILURE: 'failure',
  TIMEOUT: 'timeout',
  PENDING: 'pending',
} as const;

// Export status keys as a type
export type SuperadminWebhookStatus = keyof typeof SUPERADMIN_WEBHOOK_STATUSES;

// Status groupings for different use cases
export const SUPERADMIN_STATUS_GROUPS = {
  SUCCESSFUL: ['success'] as const,
  FAILED: ['failure', 'timeout'] as const,
  PENDING: ['pending'] as const,
} as const;

// Status colors mapping for UI components
export const SUPERADMIN_STATUS_COLORS = {
  success: 'success',
  failure: 'error',
  timeout: 'error',
  pending: 'warning',
} as const;

// Status display names
export const SUPERADMIN_STATUS_DISPLAY_NAMES = {
  success: 'Success',
  failure: 'Failed',
  timeout: 'Timeout',
  pending: 'Pending',
} as const;

// Helper functions
export const isSuperadminSuccessfulStatus = (status: string): boolean => {
  return SUPERADMIN_STATUS_GROUPS.SUCCESSFUL.includes(status as any);
};

export const isSuperadminFailedStatus = (status: string): boolean => {
  return SUPERADMIN_STATUS_GROUPS.FAILED.includes(status as any);
};

export const isSuperadminPendingStatus = (status: string): boolean => {
  return SUPERADMIN_STATUS_GROUPS.PENDING.includes(status as any);
};

export const getSuperadminStatusColor = (status: string): string => {
  return SUPERADMIN_STATUS_COLORS[status as keyof typeof SUPERADMIN_STATUS_COLORS] || 'default';
};

export const getSuperadminStatusDisplayName = (status: string): string => {
  return SUPERADMIN_STATUS_DISPLAY_NAMES[status as keyof typeof SUPERADMIN_STATUS_DISPLAY_NAMES] || status;
};
